import { css } from '@emotion/react';
import usingPhoneBackground from '@assets/images/using_phone_background.png';
import { Gray, White } from '@constants/color';

export const container = css({
  display: 'flex',
  flexDirection: 'row',
  width: '1920px',
  height: '1080px',
  backgroundImage: `url(${usingPhoneBackground})`
});
export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px',
  padding: '64px',
  width: '1152px'
});
export const rightContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  rowGap: '40px',
  padding: '180px 64px',
  width: '512px',
  backgroundColor: Gray.Gray90
});
export const rightButtonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px',
  width: '100%'
});

export const title = css({
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});
export const subtitle = css({
  color: White.White10,
  fontSize: '32px',
  fontWeight: 700
});
